import { useState } from 'react';
import { FontAwesomeIcon } from './Icon';
import { faTag, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useCart, useSettings } from '../lib/store';
import { useI18n } from '../lib/i18n';

export function CouponForm({ totals }) {
  const { coupon, setCoupon } = useCart();
  const { t } = useI18n();
  const [code, setCode] = useState(coupon);
  return (
    <div className="mb-4">
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); setCoupon(code); }}>
        <div className="relative flex-1">
          <FontAwesomeIcon icon={faTag} className="pointer-events-none absolute top-1/2 start-3.5 -translate-y-1/2 text-slate-400" />
          <input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder={t('Coupon code')} aria-label={t('Coupon code')} className="input ps-9 uppercase" />
        </div>
        <button className="btn btn-outline btn-sm">{t('Apply')}</button>
      </form>
      {totals?.coupon && (
        <p className="mt-2 flex items-center gap-2 text-[13px] text-emerald-700">
          <span>{t('Coupon {code} applied (-{percent}%).', { code: totals.coupon.code, percent: totals.coupon.percent })}</span>
          <button type="button" className="cursor-pointer text-slate-500 underline hover:text-sale" onClick={() => { setCoupon(''); setCode(''); }}>
            <FontAwesomeIcon icon={faXmark} /> {t('Remove')}
          </button>
        </p>
      )}
      {totals?.couponError && <p className="mt-2 text-[13px] text-sale">{t(totals.couponErrorKey || totals.couponError, totals.couponErrorVars)}</p>}
    </div>
  );
}

// `t` here is the totals object (kept for existing callers); the translator is `tr`.
export function Totals({ t }) {
  const { money } = useSettings();
  const { t: tr } = useI18n();
  const row = 'flex justify-between py-1.5 text-sm';
  return (
    <div>
      <div className={row}><span>{tr('Subtotal')}</span><span>{money(t.subtotal)}</span></div>
      {t.couponDiscount > 0 && <div className={`${row} text-emerald-700`}><span>{tr('Coupon ({code})', { code: t.coupon.code })}</span><span>−{money(t.couponDiscount)}</span></div>}
      <div className={row}><span>{tr('Delivery')}</span><span>{t.delivery ? money(t.delivery) : tr('Free')}</span></div>
      {t.vatPercent > 0 && <div className={row}><span>{tr('VAT ({percent}%)', { percent: t.vatPercent })}</span><span>{money(t.vat)}</span></div>}
      <div className="mt-2 flex justify-between border-t border-slate-200 pt-3.5 text-lg font-extrabold"><span>{tr('Total')}</span><span>{money(t.total)}</span></div>
      {t.savings > 0 && <div className={`${row} font-bold text-emerald-700`}><span>{tr('You save')}</span><span>{money(t.savings)}</span></div>}
    </div>
  );
}
